import { createContext } from 'react';
const PopupContext = createContext({});
export default PopupContext;